import { useState } from "react";

export default function ConsentBanner() {
  const [choice, setChoice] = useState(() => localStorage.getItem("gpsl-consent"));
  if (choice) return null;

  const decide = (v) => {
    localStorage.setItem("gpsl-consent", v);
    setChoice(v);
  };

  return (
    <div
      role="dialog" aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-white p-4 shadow-[0_-4px_24px_rgba(15,23,42,0.08)]"
      data-testid="consent-banner"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between sm:px-4">
        <p className="max-w-2xl text-sm leading-relaxed text-brand-slate">
          We use privacy-respecting analytics (page views and feature interactions) to improve this site — only with your consent.
          Declining changes nothing about how the site works. See our <a href="/cookies" className="text-primary underline underline-offset-2">cookie policy</a>.
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => decide("declined")}
            data-testid="consent-decline"
            className="rounded-sm border border-border px-5 py-2.5 text-sm font-semibold text-brand-slate transition-colors duration-150 hover:border-primary hover:text-primary"
          >
            Decline
          </button>
          <button
            onClick={() => decide("accepted")}
            data-testid="consent-accept"
            className="rounded-sm bg-primary px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-blue-700"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
